import { Typography } from '@/components/ui/typography'
import { getAssetLink } from '@/helpers/get-asset-link'
import { ChecklistInputProviderInfo } from '@/models'

import * as S from './checklist-provider-card.styled'

interface ChecklistProviderCardProps {
  providerInfo: ChecklistInputProviderInfo
}

export const ChecklistProviderCard = ({ providerInfo }: ChecklistProviderCardProps) => {
  const { name, description, logo } = providerInfo

  return (
    <S.Container>
      <S.Header>
        {/* TODO: Create new util for getting the image link. Currently old solution is used */}
        {logo && (
          <S.Logo src={getAssetLink({ file: logo, path: 'chitown-images/checklist' })} alt={name} />
        )}
        <Typography as="span" size="text-small" weight="medium" color="black800">
          {name}
        </Typography>
      </S.Header>
      <Typography as="span" size="text-small" color="black500" breakLines={2}>
        {description}
      </Typography>
    </S.Container>
  )
}
